import styled from "styled-components";

export const RootContainer = styled.div`
	padding: 16px;

	.infinite-scroll-component__outerdiv {
		height: calc(100vh - 110px);
	}

	.infinite-scroll-component {
		height: 100% !important;
		overflow-x: hidden !important;
	}

	@media screen and (max-width: 376px) {
		padding: 12px;
	}
`;

export const HistoryBox = styled.div`
	display: flex;
	flex-direction: row;
	padding: 16px ;
	gap: 8px;
	border-radius: 16px;
	background: #F7F7F7;
	margin-bottom: 4px;

	@media screen and (max-width: 376px) {
		padding: 8px 6px;
	}
`;

export const DateAndAmountContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;
export const Date = styled.p`
	flex-grow: 1;
	color: #1E1E1E;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 26px; /* 162.5% */

	@media screen and (max-width: 376px) {
font-size: 15px;
	}
`;
export const Amount = styled.p`
	color: #006400;
	text-align: right;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */

	@media screen and (max-width: 376px) {
font-size: 15px;
	}
`;

export const ExpireBox = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: start;
	align-items: center;
	gap: 4px;
`;

export const ExpireText = styled.p`
	color: #EE3530;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */

	@media screen and (max-width: 376px) {
		font-size: 13px;
	}
`;

export const ExpiredTime = styled.p`
	color: #616161;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 171.429% */

	@media screen and (max-width: 376px) {
		font-size: 13px;
	}
`;

export const SpinWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	height: ${(props) =>
		props.size === "large" ? "calc(100vh - 110px)" : "auto"};
`;

export const EmptyText = styled.div`
	height: calc(100vh - 110px);
	align-items: center;
	justify-content: center;
	display: flex;
	flex-direction: column;
	gap: 16px;

	color: #979797;
	text-align: center;
	font-size: 18px;
	font-style: normal;
	font-weight: 700;
	line-height: 30px; /* 150% */
`;

export const HistoryWrapper = styled.div`
	border-radius: 16px;
	max-height: 700px;
`;


export const Title = styled.p`
	color: #616161;
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 26px; /* 162.5% */
`

export const DataContainer = styled.div`
	display: flex;
	flex-direction: column;

	flex: 1;
`